/* eslint-disable import/no-cycle */
/* eslint-disable react/prop-types */
import React, { useRef, useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import Modal, { ModalSize } from '../../molecules/modal/modal';
import Button, { ButtonTheme } from '../../atoms/button/button';
import { getCatalog, createItem, getSortedItems } from '../../../store/externalCalls/api/listTableApi';
import { composeURL, appendParamsToURL } from '../../../utils/urlTools';
import TableSection from '../tableSection/tableSectionv2';
import swal from "sweetalert";

const LoadFromCatalog = (props) => {
  const {
    title,
    onClose,
    configFile,
    selectedValue,
    size,
    multiple,
  } = props;

  const childRef = useRef();
  const dispatch = useDispatch();
  const params = useParams();
  const [dataPaginated, setData] = useState(undefined);
  const [itemsSelected, setitemsSelected] = useState(selectedValue?selectedValue:[]);
  const session = useSelector((state) => state.session);
  const id = configFile.idAttribute !== undefined
    ? params[configFile.idAttribute] : undefined;

  const handlerSave = async () => {
    try {
      const url = configFile.createURL ? composeURL(session, configFile.sessionParams, configFile.createURL) : null;
      const loadPageUrl = configFile.loadPage
        ? composeURL(session, configFile.sessionParams, configFile.loadPage)
        : null;

      if (configFile.createURL !== undefined) {
        if (loadPageUrl) {
          await createItem(url, itemsSelected, dispatch, loadPageUrl);
        } else {
          await createItem(url, itemsSelected, dispatch);
        }
      }
      onClose(itemsSelected);
    } catch (e) {
      if(configFile?.showCreateErrorAsAlert){
        const data = e?.response?.data;
        const msg =
        e?.errors
        ? Object.values(e?.errors).flat().join("\n")
        : data?.message || e?.message || "Something went wrong";
        
        swal({
          title: "Cannot save",
          text: msg,
          icon: "error",
          buttons: {
            ok: true,
          },
        });
      }else{
       onClose(itemsSelected);
      }
    }
  };
  const handlerClose = () => {
    onClose();
  };

  const handlerClickRow = (newitemsSelected) => {
    setitemsSelected(newitemsSelected);
  };

  const handlerChangePage = (url) => {
    getCatalog(url).then((response) => {
      setData(response);
    });
  };

  const handlerSort = (sort) => {
    const { attributeName, sortDown } = sort;
    const orderList = sortDown ? 'asc' : 'desc';
    const obj = {
      sort_by: attributeName,
      order: orderList,
    };
    const url = composeURL(session, configFile.sessionParams, configFile.getURL, id);
    const searchURL = appendParamsToURL(url, obj);

    getSortedItems(searchURL, dispatch);
  };

  const handlerSearch = (filters) => {
    const searchURL = appendParamsToURL(composeURL(session, configFile.sessionParams, configFile.getURL, id), filters);
    getCatalog(searchURL).then((response) => {
      setData(response);
    });
  };

  useEffect(() => {
    if (configFile.getURL !== undefined) {
      getCatalog(composeURL(session, configFile.sessionParams, configFile.getURL, id)).then((response) => {
        setData(response);
      });
    }
  }, [configFile]);

  return (
    <Modal
      size={size?size:ModalSize.LARGE}
      ref={childRef}
      onClose={handlerClose}
      title={title}
    >
      { dataPaginated !== undefined
        && (
          <TableSection
            configFile={configFile}
            valuesPaginated={dataPaginated}
            onChangePage={handlerChangePage}
            onClickRow={handlerClickRow}
            onSearch={handlerSearch}
            onSort={handlerSort}
            initDataSelected={configFile.isMultiSelectable === true ? itemsSelected : selectedValue ? selectedValue : selectedValue}
          />
        )}
      <div>
        <Button
          id={`${configFile.attributeName}-ok`}
          theme={ButtonTheme.PRIMARY}
          onClick={handlerSave}
          disabled={itemsSelected === undefined || itemsSelected.length === 0}
        >
          Ok
        </Button>
      </div>
    </Modal>
  );
};

LoadFromCatalog.propTypes = {
  /**
   * Modal title
   */
  title: PropTypes.string,
  /**
   * Event callback when the modal is closed
   */
  onClose: PropTypes.func,
  /**
   * Configuration file to create a table
   */
  configFile: PropTypes.shape({}),
};

LoadFromCatalog.defaultProps = {
  title: '',
  configFile: {},
  multiple: false,
  onClose: () => { },
};

export default LoadFromCatalog;
